// FETCH LOCALES
export const PARTNERS = 'PARTNERS'
export const FETCH_PARTNERS_REQUEST = 'FETCH_PARTNERS_REQUEST'
export const FETCH_PARTNERS_FAILURE = 'FETCH_PARTNERS_FAILURE'
export const FETCH_PARTNERS_SUCCESS = 'FETCH_PARTNERS_SUCCESS'
export const FETCH_INITIAL_DATA_REQUEST = 'FETCH_INITIAL_DATA_REQUEST'
export const FETCH_INITIAL_DATA_FAILURE = 'FETCH_INITIAL_DATA_FAILURE'
export const FETCH_INITIAL_DATA_SUCCESS = 'FETCH_INITIAL_DATA_SUCCESS'
// POST GAME_CODE
export const GAME_CODE = 'GAME_CODE'
export const POST_GAME_CODE_REQUEST = 'POST_GAME_CODE_REQUEST'
export const POST_GAME_CODE_FAILURE = 'POST_GAME_CODE_FAILURE'
export const POST_GAME_CODE_SUCCESS = 'POST_GAME_CODE_SUCCESS'
// POST FREE_GAME_LOGIN
export const POST_FREE_GAME_LOGIN_REQUEST = 'POST_FREE_GAME_LOGIN_REQUEST'
export const POST_FREE_GAME_LOGIN_FAILURE = 'POST_FREE_GAME_LOGIN_FAILURE'
export const POST_FREE_GAME_LOGIN_SUCCESS = 'POST_FREE_GAME_LOGIN_SUCCESS'
// POST CHECK_TIMER_SET
export const CHECK_TIMER_SET_REQUEST = 'CHECK_TIMER_SET_REQUEST'
export const CHECK_TIMER_SET_FAILURE = 'CHECK_TIMER_SET_FAILURE'
export const CHECK_TIMER_SET_SUCCESS = 'CHECK_TIMER_SET_SUCCESS'
// FETCH FETCH_LEGAL_URLS
export const FETCH_LEGAL_URLS_REQUEST = 'FETCH_LEGAL_URLS_REQUEST'
export const FETCH_LEGAL_URLS_FAILURE = 'FETCH_LEGAL_URLS_FAILURE'
export const FETCH_LEGAL_URLS_SUCCESS = 'FETCH_LEGAL_URLS_SUCCESS'
// FETCH FETCH_IS_QUESTION_SOLVED
export const FETCH_IS_QUESTION_SOLVED_REQUEST =
  'FETCH_IS_QUESTION_SOLVED_REQUEST'
export const FETCH_IS_QUESTION_SOLVED_FAILURE =
  'FETCH_IS_QUESTION_SOLVED_FAILURE'
export const FETCH_IS_QUESTION_SOLVED_SUCCESS =
  'FETCH_IS_QUESTION_SOLVED_SUCCESS'
// POST TEAM_NAME
export const TEAM_NAME = 'TEAM_NAME'
export const POST_TEAM_NAME_REQUEST = 'POST_TEAM_NAME_REQUEST'
export const POST_TEAM_NAME_FAILURE = 'POST_TEAM_NAME_FAILURE'
export const POST_TEAM_NAME_SUCCESS = 'POST_TEAM_NAME_SUCCESS'
export const CHECK_IF_TEAM_NAME_IS_ADDED_REQUEST =
  'CHECK_IF_TEAM_NAME_IS_ADDED_REQUEST'
export const CHECK_IF_TEAM_NAME_IS_ADDED_FAILURE =
  'CHECK_IF_TEAM_NAME_IS_ADDED_FAILURE'
export const CHECK_IF_TEAM_NAME_IS_ADDED_SUCCESS =
  'CHECK_IF_TEAM_NAME_IS_ADDED_SUCCESS'
// PUT TEAM_NAME
// export const TEAM_NAME = 'TEAM_NAME'
export const PUT_TEAM_NAME_REQUEST = 'PUT_TEAM_NAME_REQUEST'
export const PUT_TEAM_NAME_FAILURE = 'PUT_TEAM_NAME_FAILURE'
export const PUT_TEAM_NAME_SUCCESS = 'PUT_TEAM_NAME_SUCCESS'
// POST BOOK_GAME
export const BOOK_GAME = 'BOOK_GAME'
export const POST_BOOK_GAME_REQUEST = 'POST_BOOK_GAME_REQUEST'
export const POST_BOOK_GAME_FAILURE = 'POST_BOOK_GAME_FAILURE'
export const POST_BOOK_GAME_SUCCESS = 'POST_BOOK_GAME_SUCCESS'
// FETCH BOOKED_GAMES_BY_USER
export const BOOKED_GAMES_BY_USER = 'BOOKED_GAMES_BY_USER'
export const FETCH_BOOKED_GAMES_BY_USER_REQUEST =
  'FETCH_BOOKED_GAMES_BY_USER_REQUEST'
export const FETCH_BOOKED_GAMES_BY_USER_FAILURE =
  'FETCH_BOOKED_GAMES_BY_USER_FAILURE'
export const FETCH_BOOKED_GAMES_BY_USER_SUCCESS =
  'FETCH_BOOKED_GAMES_BY_USER_SUCCESS'
// FETCH BOOKED_GAMES_BY_CITIES
export const BOOKED_GAMES_BY_CITIES = 'BOOKED_GAMES_BY_CITIES'
export const FETCH_BOOKED_GAMES_BY_CITIES_REQUEST =
  'FETCH_BOOKED_GAMES_BY_CITIES_REQUEST'
export const FETCH_BOOKED_GAMES_BY_CITIES_FAILURE =
  'FETCH_BOOKED_GAMES_BY_CITIES_FAILURE'
export const FETCH_BOOKED_GAMES_BY_CITIES_SUCCESS =
  'FETCH_BOOKED_GAMES_BY_CITIES_SUCCESS'
// FETCH BOOKED_GAMES_TOTALS_IN_RANGE
export const BOOKED_GAMES_TOTALS_IN_RANGE = 'BOOKED_GAMES_TOTALS_IN_RANGE'
export const FETCH_BOOKED_GAMES_TOTALS_IN_RANGE_REQUEST =
  'FETCH_BOOKED_GAMES_TOTALS_IN_RANGE_REQUEST'
export const FETCH_BOOKED_GAMES_TOTALS_IN_RANGE_FAILURE =
  'FETCH_BOOKED_GAMES_TOTALS_IN_RANGE_FAILURE'
export const FETCH_BOOKED_GAMES_TOTALS_IN_RANGE_SUCCESS =
  'FETCH_BOOKED_GAMES_TOTALS_IN_RANGE_SUCCESS'
// FETCH BOOKED_GAMES_TOTALS
export const BOOKED_GAMES_TOTALS = 'BOOKED_GAMES_TOTALS'
export const FETCH_BOOKED_GAMES_TOTALS_REQUEST =
  'FETCH_BOOKED_GAMES_TOTALS_REQUEST'
export const FETCH_BOOKED_GAMES_TOTALS_FAILURE =
  'FETCH_BOOKED_GAMES_TOTALS_FAILURE'
export const FETCH_BOOKED_GAMES_TOTALS_SUCCESS =
  'FETCH_BOOKED_GAMES_TOTALS_SUCCESS'
// FETCH LEADERBOARD
export const LEADERBOARD = 'LEADERBOARD'
export const FETCH_LEADERBOARD_REQUEST = 'FETCH_LEADERBOARD_REQUEST'
export const FETCH_LEADERBOARD_FAILURE = 'FETCH_LEADERBOARD_FAILURE'
export const FETCH_LEADERBOARD_SUCCESS = 'FETCH_LEADERBOARD_SUCCESS'
// FETCH TEAM_ON_LEADERBOARD
export const TEAM_ON_LEADERBOARD = 'TEAM_ON_LEADERBOARD'
export const FETCH_TEAM_ON_LEADERBOARD_REQUEST =
  'FETCH_TEAM_ON_LEADERBOARD_REQUEST'
export const FETCH_TEAM_ON_LEADERBOARD_FAILURE =
  'FETCH_TEAM_ON_LEADERBOARD_FAILURE'
export const FETCH_TEAM_ON_LEADERBOARD_SUCCESS =
  'FETCH_TEAM_ON_LEADERBOARD_SUCCESS'
// FETCH GAMES_BY_USER
export const GAMES_BY_USER = 'GAMES_BY_USER'
export const FETCH_GAMES_BY_USER_REQUEST = 'FETCH_GAMES_BY_USER_REQUEST'
export const FETCH_GAMES_BY_USER_FAILURE = 'FETCH_GAMES_BY_USER_FAILURE'
export const FETCH_GAMES_BY_USER_SUCCESS = 'FETCH_GAMES_BY_USER_SUCCESS'
// FETCH GAME_CODE
// export const GAME_CODE = 'GAME_CODE'
export const FETCH_GAME_CODE_REQUEST = 'FETCH_GAME_CODE_REQUEST'
export const FETCH_GAME_CODE_FAILURE = 'FETCH_GAME_CODE_FAILURE'
export const FETCH_GAME_CODE_SUCCESS = 'FETCH_GAME_CODE_SUCCESS'
// FETCH WELCOME_SCREEN
export const WELCOME_SCREEN = 'WELCOME_SCREEN'
export const FETCH_WELCOME_SCREEN_REQUEST = 'FETCH_WELCOME_SCREEN_REQUEST'
export const FETCH_WELCOME_SCREEN_FAILURE = 'FETCH_WELCOME_SCREEN_FAILURE'
export const FETCH_WELCOME_SCREEN_SUCCESS = 'FETCH_WELCOME_SCREEN_SUCCESS'
// FETCH END_SCREEN
export const END_SCREEN = 'END_SCREEN'
export const FETCH_END_SCREEN_REQUEST = 'FETCH_END_SCREEN_REQUEST'
export const FETCH_END_SCREEN_FAILURE = 'FETCH_END_SCREEN_FAILURE'
export const FETCH_END_SCREEN_SUCCESS = 'FETCH_END_SCREEN_SUCCESS'
// FETCH GAME_LOCALES
export const GAME_LOCALES = 'GAME_LOCALES'
export const FETCH_GAME_LOCALES_REQUEST = 'FETCH_GAME_LOCALES_REQUEST'
export const FETCH_GAME_LOCALES_FAILURE = 'FETCH_GAME_LOCALES_FAILURE'
export const FETCH_GAME_LOCALES_SUCCESS = 'FETCH_GAME_LOCALES_SUCCESS'
// FETCH MAP_STYLE
export const MAP_STYLE = 'MAP_STYLE'
export const FETCH_MAP_STYLE_REQUEST = 'FETCH_MAP_STYLE_REQUEST'
export const FETCH_MAP_STYLE_FAILURE = 'FETCH_MAP_STYLE_FAILURE'
export const FETCH_MAP_STYLE_SUCCESS = 'FETCH_MAP_STYLE_SUCCESS'
// FETCH LOCATIONS_ON_MAP
export const LOCATIONS_ON_MAP = 'LOCATIONS_ON_MAP'
export const FETCH_LOCATIONS_ON_MAP_REQUEST = 'FETCH_LOCATIONS_ON_MAP_REQUEST'
export const FETCH_LOCATIONS_ON_MAP_FAILURE = 'FETCH_LOCATIONS_ON_MAP_FAILURE'
export const FETCH_LOCATIONS_ON_MAP_SUCCESS = 'FETCH_LOCATIONS_ON_MAP_SUCCESS'
// FETCH QUESTION_BY_LOCALE
export const QUESTION_BY_LOCALE = 'QUESTION_BY_LOCALE'
export const FETCH_QUESTION_BY_LOCALE_REQUEST =
  'FETCH_QUESTION_BY_LOCALE_REQUEST'
export const FETCH_QUESTION_BY_LOCALE_FAILURE =
  'FETCH_QUESTION_BY_LOCALE_FAILURE'
export const FETCH_QUESTION_BY_LOCALE_SUCCESS =
  'FETCH_QUESTION_BY_LOCALE_SUCCESS'
// POST PUZZLE_ANSWER
export const PUZZLE_ANSWER = 'PUZZLE_ANSWER'
export const POST_PUZZLE_ANSWER_REQUEST = 'POST_PUZZLE_ANSWER_REQUEST'
export const POST_PUZZLE_ANSWER_FAILURE = 'POST_PUZZLE_ANSWER_FAILURE'
export const POST_PUZZLE_ANSWER_SUCCESS = 'POST_PUZZLE_ANSWER_SUCCESS'
// POST PUZZLE_HINT
export const PUZZLE_HINT = 'PUZZLE_HINT'
export const POST_PUZZLE_HINT_REQUEST = 'POST_PUZZLE_HINT_REQUEST'
export const POST_PUZZLE_HINT_FAILURE = 'POST_PUZZLE_HINT_FAILURE'
export const POST_PUZZLE_HINT_SUCCESS = 'POST_PUZZLE_HINT_SUCCESS'
// FETCH USED_HINTS
export const USED_HINTS = 'USED_HINTS'
export const FETCH_USED_HINTS_REQUEST = 'FETCH_USED_HINTS_REQUEST'
export const FETCH_USED_HINTS_FAILURE = 'FETCH_USED_HINTS_FAILURE'
export const FETCH_USED_HINTS_SUCCESS = 'FETCH_USED_HINTS_SUCCESS'
// POST SKIP_PUZZLE
export const SKIP_PUZZLE = 'SKIP_PUZZLE'
export const POST_SKIP_PUZZLE_REQUEST = 'POST_SKIP_PUZZLE_REQUEST'
export const POST_SKIP_PUZZLE_FAILURE = 'POST_SKIP_PUZZLE_FAILURE'
export const POST_SKIP_PUZZLE_SUCCESS = 'POST_SKIP_PUZZLE_SUCCESS'
// CHANGE_SELECTED_LANGUAGE
export const CHANGE_SELECTED_LANGUAGE = 'CHANGE_SELECTED_LANGUAGE'
// RESET_PUZZLE_ANSWER
export const SET_PUZZLE_ANSWER = 'SET_PUZZLE_ANSWER'
export const RESET_PUZZLE_ANSWER = 'RESET_PUZZLE_ANSWER'
// FETCH COLLECTED_ITEMS
export const COLLECTED_ITEMS = 'COLLECTED_ITEMS'
export const FETCH_COLLECTED_ITEMS_REQUEST = 'FETCH_COLLECTED_ITEMS_REQUEST'
export const FETCH_COLLECTED_ITEMS_FAILURE = 'FETCH_COLLECTED_ITEMS_FAILURE'
export const FETCH_COLLECTED_ITEMS_SUCCESS = 'FETCH_COLLECTED_ITEMS_SUCCESS'
// FETCH FINAL_PUZZLE
export const FINAL_PUZZLE = 'FINAL_PUZZLE'
export const FETCH_FINAL_PUZZLE_REQUEST = 'FETCH_FINAL_PUZZLE_REQUEST'
export const FETCH_FINAL_PUZZLE_FAILURE = 'FETCH_FINAL_PUZZLE_FAILURE'
export const FETCH_FINAL_PUZZLE_SUCCESS = 'FETCH_FINAL_PUZZLE_SUCCESS'
// FETCH TEAM NAME
export const FETCH_TEAM_NAME_REQUEST = 'FETCH_TEAM_NAME_REQUEST'
export const FETCH_TEAM_NAME_FAILURE = 'FETCH_TEAM_NAME_FAILURE'
export const FETCH_TEAM_NAME_SUCCESS = 'FETCH_TEAM_NAME_SUCCESS'
// FETCH PROGRESS
export const FETCH_PROGRESS_REQUEST = 'FETCH_PROGRESS_REQUEST'
export const FETCH_PROGRESS_FAILURE = 'FETCH_PROGRESS_FAILURE'
export const FETCH_PROGRESS_SUCCESS = 'FETCH_PROGRESS_SUCCESS'
// POST LOGOUT
export const LOGOUT = 'LOGOUT'
export const POST_LOGOUT_REQUEST = 'POST_LOGOUT_REQUEST'
export const POST_LOGOUT_FAILURE = 'POST_LOGOUT_FAILURE'
export const POST_LOGOUT_SUCCESS = 'POST_LOGOUT_SUCCESS'
// FETCH WELL_DONE_BACKGROUND
export const WELL_DONE_BACKGROUND = 'WELL_DONE_BACKGROUND'
export const FETCH_WELL_DONE_BACKGROUND_REQUEST =
  'FETCH_WELL_DONE_BACKGROUND_REQUEST'
export const FETCH_WELL_DONE_BACKGROUND_FAILURE =
  'FETCH_WELL_DONE_BACKGROUND_FAILURE'
export const FETCH_WELL_DONE_BACKGROUND_SUCCESS =
  'FETCH_WELL_DONE_BACKGROUND_SUCCESS'
// CHANGE_GLOBAL_VOLUME
export const CHANGE_GLOBAL_VOLUME = 'CHANGE_GLOBAL_VOLUME'
export const SET_GAME_TIMER_DIALOG = 'SET_GAME_TIMER_DIALOG'
export const SET_GAME_TIMER_REMINDER_DIALOG = 'SET_GAME_TIMER_REMINDER_DIALOG'
export const FETCH_GAME_CONSENT_REQUEST = 'FETCH_GAME_CONSENT_REQUEST'
export const FETCH_GAME_CONSENT_FAILURE = 'FETCH_GAME_CONSENT_FAILURE'
export const FETCH_GAME_CONSENT_SUCCESS = 'FETCH_GAME_CONSENT_SUCCESS'
export const FETCH_GAME_INSTRUCTIONS_REQUEST = 'FETCH_GAME_INSTRUCTIONS_REQUEST'
export const FETCH_GAME_INSTRUCTIONS_FAILURE = 'FETCH_GAME_INSTRUCTIONS_FAILURE'
export const FETCH_GAME_INSTRUCTIONS_SUCCESS = 'FETCH_GAME_INSTRUCTIONS_SUCCESS'
export const FETCH_QUESTION_SOLVED_PUZZLE_BY_LOCALE_REQUEST =
  'FETCH_QUESTION_SOLVED_PUZZLE_BY_LOCALE_REQUEST'
export const FETCH_QUESTION_SOLVED_PUZZLE_BY_LOCALE_FAILURE =
  'FETCH_QUESTION_SOLVED_PUZZLE_BY_LOCALE_FAILURE'
export const FETCH_QUESTION_SOLVED_PUZZLE_BY_LOCALE_SUCCESS =
  'FETCH_QUESTION_SOLVED_PUZZLE_BY_LOCALE_SUCCESS'
